var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContentLink18 = function SvgContentLink18(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.943 10.057a.73.73 0 010 1.066.756.756 0 01-1.065 0 3.753 3.753 0 010-5.303l2.655-2.655a3.753 3.753 0 015.302 0 3.753 3.753 0 010 5.302l-1.118 1.118a5.18 5.18 0 00-.3-1.815l.353-.36a2.236 2.236 0 000-3.18 2.236 2.236 0 00-3.18 0L7.943 6.877a2.236 2.236 0 000 3.18zm2.114-3.18a.756.756 0 011.066 0 3.753 3.753 0 010 5.303l-2.655 2.655a3.753 3.753 0 01-5.303 0 3.753 3.753 0 010-5.303l1.118-1.117a5.25 5.25 0 00.3 1.823l-.353.352a2.236 2.236 0 000 3.18 2.236 2.236 0 003.18 0l2.647-2.647a2.236 2.236 0 000-3.18.73.73 0 010-1.066z",
    clipRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContentLink18, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "a0500e030edfdbabb55d030a07278d8a.svg";
export { ForwardRef as ReactComponent };